import "./Counts.scss";
import countList from "./CountsData";

const Counts = () => {
  return (
    <div className="counts">
      <ul className="counts__list">
        {countList.map(({ count, desc }, index) => (
          <li className="counts__item" key={index}>
            <span className="counts__number">{count}</span>
            <p className="counts__text">{desc}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Counts;
